var map = {
	"./image-17.png": 72,
	"./image-19.png": 73,
	"./image-20.png": 74,
	"./image-21.png": 75,
	"./image-22.png": 76,
	"./image-24.png": 77,
	"./image-27.png": 78,
	"./image-28.png": 79,
	"./image-29.png": 80,
	"./image-30.png": 81,
	"./image-31.png": 82,
	"./image-32.png": 83,
	"./image-33.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;